import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
interface MuteComponentProp {}
function MuteComponent(props: MuteComponentProp) {
  const [isMuted, setIsMuted] = useState(false);


  const checkMutedStatus = () => {
    if (!window) return;
    // Example: Replace this logic with how you check the muted status
    const mutedStatus = (window as any)?.createjs.Sound.muted == false; // Simulating a check
    setIsMuted(mutedStatus);
    console.log("Muted Status Checked:", mutedStatus);
  };

  useEffect(() => {
    // Call the function immediately and set up the interval
    checkMutedStatus();
    const intervalId = setInterval(() => {
      checkMutedStatus();
    }, 30000); // 30 seconds

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="outline secondary"
      style={{
        position: "absolute",
        right: 10,
        top: 10,
      }}
    >
      <button
        style={{ marginRight: 5 }}
        onClick={() => {
         
          if (!window) return;
          (window as any).location.href= "/"
         
        }}
      >
        Back
      </button>
      <button
        onClick={() => {
          console.log({ window: (window as any)?.createjs.Sound.setMute });
          if (!window) return;
          (window as any)?.createjs.Sound.setMute(isMuted);
          checkMutedStatus();
        }}
      >
        {!isMuted ? "Unmute" : "Mute"}
      </button>
    </div>
  );
}

export default MuteComponent;
